import { Tabs as BaseTabs } from '@base-ui/react/tabs';
import { styled } from '../lib/styled.tsx';

/**
 * Tabbed panels, with the underline animated between tabs.
 *
 * `Indicator` reads the active tab's geometry from the `--active-tab-*` custom
 * properties Base UI keeps on the list, so it slides instead of jumping. It is
 * optional — leave it out for a plain, non-animated tab row.
 */
export const Tabs = {
  Root: styled(BaseTabs.Root, 'flex w-full flex-col gap-4'),
  List: styled(BaseTabs.List, 'relative flex items-center gap-1 border-b border-border-subtle'),
  Tab: styled(
    BaseTabs.Tab,
    'relative z-1 inline-flex h-9 items-center justify-center px-2.5 whitespace-nowrap ' +
      'text-xs font-semibold text-ink-muted select-none outline-none ' +
      'transition-colors duration-150 ease-out-quint ' +
      'hover:not-data-disabled:text-ink data-active:text-ink ' +
      'data-disabled:cursor-not-allowed data-disabled:text-ink-faint',
  ),
  Indicator: styled(
    BaseTabs.Indicator,
    // Ink, not coral: the product underlines the active tab in its text
    // colour and saves coral for things you have *chosen*, not navigated to.
    'absolute bottom-0 left-0 h-0.5 rounded-full bg-ink ' +
      'w-[var(--active-tab-width)] translate-x-[var(--active-tab-left)] ' +
      'transition-[translate,width] duration-200 ease-out-quint',
  ),
  Panel: styled(BaseTabs.Panel, 'outline-none'),
};
